(() => {

  var CollectionBundleHighlightApp = (() => {
    const maxWidth = 1180;
    var setPaddingWidthProperty = () => {
      document.querySelectorAll('[js-collection-bundle-highlight]').forEach(element => {
        element.style.setProperty('--padding-left', (element.clientWidth - maxWidth) / 2 + 'px');
      });
    }
    var initialize = () => {
      window.dispatchEvent(new Event('resize'));
      window.addEventListener('resize', () => {
        setPaddingWidthProperty();
      })
    }
    return {
      init: initialize
    }
  })();


  var AnchorApp = (() => {
    var initialize = () => {
      if (window.location.hash === '#bundles') {
        setTimeout(() => {
          if (window.innerWidth < 960) {
            const bundlesSection = document.querySelector('.product-bundle__mobile');
            if (bundlesSection) {
              window.scrollTo(0, bundlesSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          } else {
            const bundlesSection = document.querySelector('.product-bundle__desktop');
            if (bundlesSection) {
              window.scrollTo(0, bundlesSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          }
        }, 500);
      }
      if (window.location.hash === '#mobile-pdp-size-picker') {
        setTimeout(() => {
          if (window.innerWidth < 960) {
            const targetSection = document.querySelector('.product__size-picker.desktop-hide');
            if (targetSection) {
              window.scrollTo(0, targetSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          }
        }, 500);
      }
    }
    return {
      init: initialize
    }
  })();

  // Custom dropdown initialization function
  var initializeCustomDropdowns = () => {
    document.querySelectorAll('[js-custom-option-select]:not(.select-hidden)').forEach(function(selectElement) {
        var numberOfOptions = selectElement.children.length;
        var optionName = selectElement.dataset.optionName
        if(optionName) {
            optionName = optionName + ' : '
        } else {
            optionName = ''
        }
        selectElement.classList.add('select-hidden');

        var wrapper = document.createElement('div');
        wrapper.className = 'select';
        selectElement.parentNode.insertBefore(wrapper, selectElement);
        wrapper.appendChild(selectElement);

        var styledSelect = document.createElement('div');
        styledSelect.className = 'select-styled';
        styledSelect.textContent = optionName + selectElement.querySelector("option[selected]").textContent;
        wrapper.appendChild(styledSelect);

        var list = document.createElement('ul');
        list.className = 'select-options';
        wrapper.appendChild(list);

        for (var i = 0; i < numberOfOptions; i++) {
            var listItem = document.createElement('li');
            listItem.textContent = selectElement.children[i].textContent;
            listItem.setAttribute('rel', selectElement.children[i].value);
            list.appendChild(listItem);

            if (selectElement.children[i].selected) {
                listItem.classList.add('is-selected');
            }
        }

        var listItems = list.children;

        styledSelect.addEventListener('click', function(e) {
            e.stopPropagation();
            document.querySelectorAll('div.select-styled.active').forEach(function(activeStyledSelect) {
                if (activeStyledSelect !== styledSelect) {
                    activeStyledSelect.classList.remove('active');
                    activeStyledSelect.nextElementSibling.style.display = 'none';
                }
            });
            styledSelect.classList.toggle('active');
            list.style.display = styledSelect.classList.contains('active') ? 'block' : 'none';
        });

        styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 0.984374L7 4.98438L13 0.984375" stroke="#2B2B2B" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div>`);

        Array.from(listItems).forEach(function(listItem) {
            listItem.addEventListener('click', function(e) {
                e.stopPropagation();
                let optionName = styledSelect.closest('.select').querySelector('select').dataset.optionName
                if(optionName) {
                    optionName = optionName + ' : '
                } else {
                    optionName=''
                }
                styledSelect.textContent = optionName + listItem.textContent;
                
                styledSelect.classList.remove('active');
                selectElement.value = listItem.getAttribute('rel');
                list.querySelector('li.is-selected').classList.remove('is-selected');
                listItem.classList.add('is-selected');
                list.style.display = 'none';
                styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.984374L7 4.98438L13 0.984375" stroke="#2B2B2B" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </div>`);
                selectElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}))
            });

        });

        document.addEventListener('click', function() {
            styledSelect.classList.remove('active');
            list.style.display = 'none';
        });
    });
  };

  var ProductMeasurementInfoWrapperApp = (() => {
    var switchElement = (variant_id) => {
      document.querySelectorAll('[js-product-measurement-info-wrapper]').forEach(element => {
        if (element.getAttribute('data-variant-id') == String(variant_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
    var initialize = () => {
      document.addEventListener('product:variant-change', (event) => {
        switchElement(event.detail.variant.id)
      });
    }
    return {
      init: initialize
    }
  })();

  var PDPSizePickerApp = (() => {
    var initializeAllAnimations = (container) => {
      if (!container) return;

      container.querySelectorAll('.animation-fade-up-reveal:not(.animation-initialized)').forEach(element => {
        element.classList.add('animation-initialized');
      });
    };

    // Helper: ensure only one [name="id"] (hidden) is submitted
    var normalizeIdInputs = (formEl, variantId) => {
      if (!formEl) return;
      // Remove name from any non-hidden id fields to avoid duplicate submission
      formEl.querySelectorAll('[name="id"]').forEach(node => {
        if (!(node.tagName && node.tagName.toLowerCase() === 'input' && node.type === 'hidden')) {
          node.setAttribute('data-name', 'id');
          node.removeAttribute('name');
          // Also disable to prevent accidental serialization by libraries
          node.disabled = true;
        }
      });
      // Ensure hidden input exists and has correct value
      let hidden = formEl.querySelector('input[type="hidden"][name="id"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'id';
        formEl.appendChild(hidden);
      }
      if (variantId) hidden.value = variantId;
    };

    // Helper: set [name="id"] based on current option selections
    var syncHiddenIdFromOptions = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const sectionEl = productSection.querySelector('[data-section-id]') || document.querySelector('[data-section-id]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        if (!sectionEl || !formEl) {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: missing section/form', { hasSection: !!sectionEl, hasForm: !!formEl });
          return;
        }
        let productData;
        const productJsonEl = document.querySelector('#ProductJson-' + sectionEl.getAttribute('data-section-id'));
        if (productJsonEl) {
          try { productData = JSON.parse(productJsonEl.textContent); } catch(_) {}
        } else if (window.__pdpProductData) {
          productData = window.__pdpProductData;
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: using cached product data');
        } else {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: missing productJson, using fallbacks');
        }

        // Gather selected option values in order from variants block, then form, then section
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
        const selectedOptions = optionInputs.map(input => input.value);

        // Try resolve via product data + options first
        let variantIdToUse;
        if (productData && productData.variants && selectedOptions.length) {
          const matched = productData.variants.find(v => v && v.options && selectedOptions.every((val, idx) => String(v.options[idx]) === String(val)));
          if (matched) variantIdToUse = matched.id;
        }

        // Fallbacks in order
        if (!variantIdToUse) {
          const currentVariantIdAttr = variantsWrap?.getAttribute('data-current-variant-id');
          if (currentVariantIdAttr) {
            variantIdToUse = currentVariantIdAttr;
            console.log('[PDPSizePicker] syncHiddenIdFromOptions: used data-current-variant-id', { variantIdToUse });
          }
        }
        if (!variantIdToUse && formEl.dataset.currentProductId) {
          variantIdToUse = formEl.dataset.currentProductId;
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: used form dataset currentProductId', { variantIdToUse });
        }
        if (!variantIdToUse) {
          const idSelect = formEl.querySelector('select[data-name="id"], select[name="id"]');
          const value = idSelect?.value || idSelect?.getAttribute('value');
          if (value) {
            variantIdToUse = value;
            console.log('[PDPSizePicker] syncHiddenIdFromOptions: used fallback idSelect', { id: value });
          }
        }

        if (variantIdToUse) {
          normalizeIdInputs(formEl, variantIdToUse);
          formEl.setAttribute('data-current-product-id', variantIdToUse);
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: set id', { selectedOptions, variantIdToUse });
        } else {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: no variant resolved', { selectedOptions });
        }
      } catch (e) {
        console.log('syncHiddenIdFromOptions failed:', e);
      }
    };

    // Helper: fully reinitialize the product section via Shopify Sections API
    var reinitProductSection = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]');
        if (!productSection) {
          console.log('[PDPSizePicker] reinitProductSection: no product section found');
          return;
        }
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections) {
          if (typeof window.Shopify.theme.sections.unload === 'function') {
            console.log('[PDPSizePicker] sections.unload called');
            window.Shopify.theme.sections.unload(productSection);
          }
          if (typeof window.Shopify.theme.sections.load === 'function') {
            console.log('[PDPSizePicker] sections.load called');
            window.Shopify.theme.sections.load(productSection);
          } else {
            const evt = new Event('shopify:section:load');
            productSection.dispatchEvent(evt);
            console.log('[PDPSizePicker] dispatched shopify:section:load');
          }
        } else {
          const evt = new Event('shopify:section:load');
          productSection.dispatchEvent(evt);
          console.log('[PDPSizePicker] fallback section load event dispatched');
        }
      } catch (e) {
        console.log('reinitProductSection failed:', e);
      }
    };

    // Helper: compute selected variant from current option inputs
    var getSelectedVariantFromForm = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const sectionEl = productSection.querySelector('[data-section-id]') || document.querySelector('[data-section-id]');
        if (!sectionEl) return null;
        const productJsonEl = document.querySelector('#ProductJson-' + sectionEl.getAttribute('data-section-id'));
        let productData;
        if (productJsonEl) {
          try { productData = JSON.parse(productJsonEl.textContent); } catch(_) {}
        }
        if (!productData && window.__pdpProductData) {
          productData = window.__pdpProductData;
          console.log('[PDPSizePicker] getSelectedVariantFromForm: using cached product data');
        }
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length && formEl) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) {
          optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
          console.log('[PDPSizePicker] getSelectedVariantFromForm: using section-scoped options', { count: optionInputs.length });
        }
        const selectedOptions = optionInputs.map(input => input.value);
        // If we have product data, try to resolve full variant
        if (productData && productData.variants) {
          let variant = null;
          if (selectedOptions.length) {
            variant = productData.variants.find(v => v && v.options && selectedOptions.every((val, idx) => String(v.options[idx]) === String(val))) || null;
          }
          if (!variant && formEl) {
            const idSelectEl = formEl.querySelector('select[name="id"]');
            const idVal = idSelectEl?.value || formEl.dataset.currentProductId;
            if (idVal) {
              variant = productData.variants.find(v => String(v.id) === String(idVal)) || null;
              if (variant) console.log('[PDPSizePicker] getSelectedVariantFromForm: resolved by select id', { id: idVal });
            }
          }
          return variant;
        }
        // Fallback: no product data; return minimal variant using select id or data-current-variant-id
        const idSelectEl = formEl?.querySelector('select[name="id"]');
        const idVal = idSelectEl?.value || formEl?.dataset.currentProductId || variantsWrap?.getAttribute('data-current-variant-id');
        if (idVal) {
          const minimalVariant = { id: Number(idVal) || idVal };
          console.log('[PDPSizePicker] getSelectedVariantFromForm: minimal variant created', minimalVariant);
          return minimalVariant;
        }
        return null;
      } catch (_) { return null; }
    };

    // Helper: lightly update UI for selected variant (price, data-current-variant-id)
    var applySelectedVariantUI = (variant) => {
      try {
        if (!variant) return;
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const variantsContainer = productSection.querySelector('[data-product-variants]');
        if (variantsContainer) {
          variantsContainer.setAttribute('data-current-variant-id', variant.id);
        }
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        if (formEl) {
          formEl.setAttribute('data-current-product-id', variant.id);
        }
        // Simple price update (fallback if theme bindings are missing)
        const priceEl = productSection.querySelector('[data-price]');
        if (priceEl && typeof variant.price === 'number') {
          const price = (variant.price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          priceEl.textContent = price;
        }
        const compareEl = productSection.querySelector('[data-compare-price]');
        if (compareEl && typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price) {
          const compare = (variant.compare_at_price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          compareEl.textContent = compare;
        }
        // Notify listeners
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant } }));
        console.log('[PDPSizePicker] variant UI applied', { id: variant.id });
      } catch (e) { console.log('[PDPSizePicker] applySelectedVariantUI error', e); }
    };

    // Bind variant option listeners with delegation and logs
    var bindVariantOptionListeners = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length && formEl) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
        console.log('[PDPSizePicker] bindVariantOptionListeners: binding', { count: optionInputs.length });
        optionInputs.forEach(input => {
          input.addEventListener('change', () => {
            const currentValues = optionInputs.map(i => i.value);
            console.log('[PDPSizePicker] option change detected', { currentValues });
            syncHiddenIdFromOptions();
            const variant = getSelectedVariantFromForm();
            console.log('[PDPSizePicker] computed variant on change', { id: variant?.id });
            if (variant) applySelectedVariantUI(variant);
          });
        });

        // Delegated listener as safety net
        const delegatedHandler = (e) => {
          const target = e.target;
          if (!target || !target.matches('[name^="options"]')) return;
          if (!productSection.contains(target)) return;
          let inputs = [];
          if (variantsWrap) inputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
          if (!inputs.length && formEl) inputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
          if (!inputs.length) inputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
          const currentValues = inputs.map(i => i.value);
          console.log('[PDPSizePicker] delegated option change', { currentValues });
          syncHiddenIdFromOptions();
          const variant = getSelectedVariantFromForm();
          console.log('[PDPSizePicker] delegated computed variant', { id: variant?.id });
          if (variant) applySelectedVariantUI(variant);
        };
        if (!window.__pdpOptionDelegatedHandler) {
          window.__pdpOptionDelegatedHandler = delegatedHandler;
          document.addEventListener('change', window.__pdpOptionDelegatedHandler, true);
          console.log('[PDPSizePicker] delegated option listener attached');
        }
      } catch (e) {
        console.log('[PDPSizePicker] bindVariantOptionListeners error', e);
      }
    };

    var reinitializeGallery = () => {
      if (window.productGallerySlider) {
        try {
          window.productGallerySlider.destroy();
          window.productGallerySlider = null;
        } catch (e) {
          console.log('Error destroying main slider:', e);
        }
      }

      if (window.productThumbnailSlider) {
        try {
          window.productThumbnailSlider.destroy();
          window.productThumbnailSlider = null;
        } catch (e) {
          console.log('Error destroying thumbnail slider:', e);
        }
      }

      const mainSliderElement = document.querySelector("[js-product-main-slider]");
      if (mainSliderElement) {
        if (window.flu && window.flu.chunks && window.flu.chunks.flickity) {
          import(window.flu.chunks.flickity).then(({ Flickity }) => {
            const mainSlider = new Flickity('[js-product-main-slider]', {
              contain: true,
              adaptiveHeight: true,
              prevNextButtons: true,
              wrapAround: false,
              pageDots: false,
              cellAlign: 'left',
              draggable: true
            });

            let thumbnailSlider;
            const thumbnailElement = document.querySelector("[js-product-thumbnail-slider]");
            if (thumbnailElement) {
              thumbnailSlider = new Flickity('[js-product-thumbnail-slider]', {
                contain: true,
                prevNextButtons: false,
                wrapAround: false,
                pageDots: false,
                cellAlign: 'left',
                draggable: false,
                asNavFor: '[js-product-main-slider]' // Link to main slider
              });
              
              window.productThumbnailSlider = thumbnailSlider;
            }

            mainSlider.on('select', function(index) {
              const slideIndex = index || 0;
              
              const productMeasurementInfoWrapperList = document.querySelectorAll('[js-product-measurement-info-wrapper]');
              if (index === 2) {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.add('d-none');
                });
              } else {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.remove('d-none');
                });
              }

              const selectedSlide = mainSlider.selectedElement;
            if (selectedSlide && selectedSlide.hasAttribute('data-inspiration-image-id')) {
              productMeasurementInfoWrapperList.forEach(element => {
                element.classList.add('d-none');
              });
              document.querySelectorAll(`[js-product-inspiration-review-wrapper]`).forEach(element => {
                if (element.getAttribute('data-id') === selectedSlide.getAttribute('data-inspiration-image-id')) {
                  element.classList.add('active');
                } else {
                  element.classList.remove('active');
                }
              });
            } else {
              document.querySelectorAll(`[js-product-inspiration-review-wrapper]`).forEach(element => {
                element.classList.remove('active');
              });
            }
              
              // Only update thumbnail slider if it's not already at this index to prevent infinite loop
              if (thumbnailSlider && thumbnailSlider.selectedIndex !== index) {
                thumbnailSlider.select(index);
              }
              
              const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
              const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
              if (index > 0) {
                mediaDescriptionWrap?.classList.add("active");
              } else {
                mediaDescriptionWrap?.classList.remove("active");
              }
              mediaDescriptionEls?.forEach((item) => {
                if (slideIndex === parseInt(item.getAttribute('data-index'))) {
                  item.classList.add('active');
                } else {
                  item.classList.remove('active');
                }
              });
            });

            if (thumbnailSlider) {
              thumbnailSlider.on('select', function(index) {
                // Only update main slider if it's not already at this index to prevent infinite loop
                if (mainSlider.selectedIndex !== index) {
                  mainSlider.select(index);
                }
              });
              
              thumbnailSlider.cells.forEach((slide, index) => {
                slide.element.addEventListener("click", function() {
                  mainSlider.select(index);
                });
              });

              thumbnailSlider.on('ready', () => {
                initializeAllAnimations(thumbnailElement);
                
                // Ensure proper positioning after reinitialization
                setTimeout(() => {
                  // Force layout recalculation
                  thumbnailSlider.resize();
                  
                  // Set initial position without triggering events
                  thumbnailSlider.select(0, false, false);
                  mainSlider.select(0, false, false);
                  
                  // Manually trigger media description updates
                  const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
                  const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
                  if (mediaDescriptionWrap) {
                    mediaDescriptionWrap.classList.remove("active");
                  }
                  mediaDescriptionEls?.forEach((item) => {
                    if (parseInt(item.getAttribute('data-index')) === 0) {
                      item.classList.add('active');
                    } else {
                      item.classList.remove('active');
                    }
                  });
                  
                  // Force another resize to ensure proper layout
                  setTimeout(() => {
                    thumbnailSlider.resize();
                    mainSlider.resize();
                  }, 100);
                }, 100);
              });
            }
            
            window.productGallerySlider = mainSlider;
            
            const productTitle = document.querySelector(".product__title");
            if (productTitle) {
              const newProductTitle = productTitle.cloneNode(true);
              productTitle.parentNode.replaceChild(newProductTitle, productTitle);
              
              newProductTitle.addEventListener("click", function() {
                mainSlider.next();
              });
            }
          }).catch(e => {
            console.log('Error initializing Flickity:', e);
          });
        } else {
          setTimeout(() => {
            if (window.Flickity) {
              const mainSlider = new window.Flickity('[js-product-main-slider]', {
                contain: true,
                adaptiveHeight: true,
                prevNextButtons: true,
                wrapAround: false,
                pageDots: false,
                cellAlign: 'left'
              });
              
              const thumbnailElement = document.querySelector("[js-product-thumbnail-slider]");
              if (thumbnailElement) {
                const thumbnailSlider = new window.Flickity('[js-product-thumbnail-slider]', {
                  contain: true,
                  prevNextButtons: false,
                  wrapAround: false,
                  pageDots: false,
                  cellAlign: 'left',
                  draggable: false
                });
                
                thumbnailSlider.on('ready', () => {
                  initializeAllAnimations(thumbnailElement);
                  
                  // Ensure proper positioning after reinitialization
                  setTimeout(() => {
                    // Force layout recalculation
                    thumbnailSlider.resize();
                    
                    // Set initial position without triggering events
                    thumbnailSlider.select(0, false, false);
                    mainSlider.select(0, false, false);
                    
                    // Manually trigger media description updates
                    const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
                    const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
                    if (mediaDescriptionWrap) {
                      mediaDescriptionWrap.classList.remove("active");
                    }
                    mediaDescriptionEls?.forEach((item, i) => {
                      if (parseInt(item.getAttribute('data-index')) === 0) {
                        item.classList.add('active');
                      } else {
                        item.classList.remove('active');
                      }
                    });
                    
                    // Force another resize to ensure proper layout
                    setTimeout(() => {
                      thumbnailSlider.resize();
                      mainSlider.resize();
                    }, 100);
                  }, 100);
                });

                window.productThumbnailSlider = thumbnailSlider;
              }
              
              window.productGallerySlider = mainSlider;
            }
          }, 100);
        }
      }

      if (window.theme && window.theme.Product) {
        try {
          window.theme.Product.init();
        } catch (e) {
          console.log('Theme Product init failed:', e);
        }
      }
      
      document.dispatchEvent(new CustomEvent('gallery:reinit'));

      // Reload product section so ProductForm bindings are restored (theme uses Sections API)
      try {
        reinitProductSection();
      } catch (e) {
        console.log('Product section reload failed:', e);
      }

      window.ProductMainSliderApp.init();
    };

    var updateProductInfo = async (productUrl) => {
      try {
        window.location.href = productUrl;
        return;
        console.log('[PDPSizePicker] updateProductInfo start', { productUrl });
        const container = document.querySelector('.product__size-picker');
        if (container) container.classList.add('size-picker-loading');
        
        const response = await fetch(productUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, 'text/html');
        
        history.pushState(null, '', productUrl);
        
        document.title = newDoc.title;

        const currentTitleElement = document.querySelector('.product__title');
        const newTitleElement = newDoc.querySelector('.product__title');
        if (currentTitleElement && newTitleElement) {
          currentTitleElement.innerHTML = newTitleElement.innerHTML;
        }
        
        const currentSizePickerTitles = document.querySelectorAll('.product__size-picker .title');
        const newSizePickerTitles = newDoc.querySelectorAll('.product__size-picker .title');
        currentSizePickerTitles.forEach((currentTitle, index) => {
          if (newSizePickerTitles[index]) {
            currentTitle.innerHTML = newSizePickerTitles[index].innerHTML;
          }
        });
        
        const currentSizePickerTagText = document.querySelectorAll('.product__size-picker .tag-text');
        const newSizePickerTagText = newDoc.querySelectorAll('.product__size-picker .tag-text');
        currentSizePickerTagText.forEach((currentTagText, index) => {
          if (newSizePickerTagText[index]) {
            currentTagText.innerHTML = newSizePickerTagText[index].innerHTML;
          }
        });

        const currentSizePickerDescription = document.querySelectorAll('.product__size-picker .description');
        const newSizePickerDescription = newDoc.querySelectorAll('.product__size-picker .description');
        currentSizePickerDescription.forEach((currentDescription, index) => {
          if (newSizePickerDescription[index]) {
            currentDescription.innerHTML = newSizePickerDescription[index].innerHTML;
          }
        });
        
        const currentMediaContainer = document.querySelector('.product__media__content--media');
        const newMediaContainer = newDoc.querySelector('.product__media__content--media');
        if (currentMediaContainer && newMediaContainer) {
          currentMediaContainer.innerHTML = newMediaContainer.innerHTML;
        }
        
        const currentMobileSlider = document.querySelector('.product__media-slider');
        const newMobileSlider = newDoc.querySelector('.product__media-slider');
        if (currentMobileSlider && newMobileSlider) {
          currentMobileSlider.innerHTML = newMobileSlider.innerHTML;
        }
        
        const currentThumbnails = document.querySelector('.product-thumbnail_slider-item');
        const newThumbnails = newDoc.querySelector('.product-thumbnail_slider-item');
        if (currentThumbnails && newThumbnails) {
          currentThumbnails.innerHTML = newThumbnails.innerHTML;
          
          // Initialize animations for thumbnail elements immediately after update
          setTimeout(() => {
            // Initialize thumbnail animations
            const thumbnailAnimationElements = currentThumbnails.querySelectorAll('.animation-fade-up-reveal:not(.animation-initialized)');
            thumbnailAnimationElements.forEach(element => {
              element.classList.add('animation-initialized');
            });
            
            // Ensure first description is active and media description wrap is properly set
            const firstDescription = currentThumbnails.querySelector('.product_image-description');
            const mediaDescriptionWrap = currentThumbnails.querySelector('[js-product-media-description-wrap]');
            
            if (firstDescription) {
              currentThumbnails.querySelectorAll('.product_image-description').forEach(desc => {
                desc.classList.remove('active');
              });
              firstDescription.classList.add('active');
            }
            
            // Ensure media description wrap is properly initialized
            if (mediaDescriptionWrap) {
              // Remove active class initially, it will be set by slider events
              mediaDescriptionWrap.classList.remove('active');
            }
          }, 100);
        }

        setTimeout(() => {
          reinitializeGallery();
        }, 500);
        
        const currentPriceElement = document.querySelector('[data-price]');
        const newPriceElement = newDoc.querySelector('[data-price]');
        if (currentPriceElement && newPriceElement) {
          currentPriceElement.textContent = newPriceElement.textContent;
        }
        
        const currentComparePriceElement = document.querySelector('[data-compare-price]');
        const newComparePriceElement = newDoc.querySelector('[data-compare-price]');
        if (currentComparePriceElement && newComparePriceElement) {
          currentComparePriceElement.innerHTML = newComparePriceElement.innerHTML;
        }
        
        const currentSaleBadge = document.querySelector('[js-data-sale-badge-price]');
        const newSaleBadge = newDoc.querySelector('[js-data-sale-badge-price]');
        if (currentSaleBadge && newSaleBadge) {
          currentSaleBadge.innerHTML = newSaleBadge.innerHTML;
        } else if (currentSaleBadge && !newSaleBadge) {
          currentSaleBadge.style.display = 'none';
        } else if (!currentSaleBadge && newSaleBadge) {
          const priceContainer = document.querySelector('.product__price');
          if (priceContainer) {
            priceContainer.appendChild(newSaleBadge.cloneNode(true));
          }
        }
        
        const currentVariantContainer = document.querySelector('[data-product-variants]');
        const newVariantContainer = newDoc.querySelector('[data-product-variants]');
        if (currentVariantContainer && newVariantContainer) {
          currentVariantContainer.setAttribute('data-current-variant-id', newVariantContainer.getAttribute('data-current-variant-id'));
          currentVariantContainer.innerHTML = newVariantContainer.innerHTML;
          
          // IMPORTANT: Re-initialize custom dropdowns after variant container update
          setTimeout(() => {
            initializeCustomDropdowns();
            
            // Initialize animations for new elements
            const newAnimationElements = currentVariantContainer.querySelectorAll('.animation-fade-up-reveal:not(.animation-initialized)');
            newAnimationElements.forEach(element => {
              element.classList.add('animation-initialized');
            });
            
            // Trigger variant change event for the new variant
            const newVariantId = newVariantContainer.getAttribute('data-current-variant-id');
            if (newVariantId) {
              // Find the variant data from the product JSON
              const productJsonElement = document.querySelector('#ProductJson-' + document.querySelector('[data-section-id]').getAttribute('data-section-id'));
              if (productJsonElement) {
                try {
                  const productData = JSON.parse(productJsonElement.textContent);
                  const selectedVariant = productData.variants.find(variant => variant.id.toString() === newVariantId);
                  if (selectedVariant) {
                    document.dispatchEvent(new CustomEvent('product:variant-change', {
                      detail: { variant: selectedVariant }
                    }));
                    console.log('[PDPSizePicker] variant-change dispatched', { newVariantId });
                  }

                  // Ensure product form has a valid hidden id input set to the current variant
                  const productFormEl = document.querySelector('form[data-product-form]');
                  if (productFormEl) {
                    let idInput = productFormEl.querySelector('[name="id"]');
                    if (!idInput || idInput.tagName.toLowerCase() !== 'input') {
                      // prefer hidden input separate from fallback select
                      idInput = productFormEl.querySelector('[name="id"][type="hidden"]');
                      if (!idInput) {
                        idInput = document.createElement('input');
                        idInput.type = 'hidden';
                        idInput.name = 'id';
                        productFormEl.appendChild(idInput);
                      }
                    }
                    idInput.value = newVariantId;
                    productFormEl.setAttribute('data-current-product-id', newVariantId);
                    console.log('[PDPSizePicker] product form id set after variant container update', { newVariantId });
                  }
                } catch (e) {
                  console.log('Could not parse product data for variant change:', e);
                }
              }
            }

            // Wire listeners so future option changes keep id in sync
            const formEl = document.querySelector('form[data-product-form]');
            if (formEl) {
              const optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
              optionInputs.forEach(input => {
                input.addEventListener('change', syncHiddenIdFromOptions);
              });
            }
            // Initial sync
            syncHiddenIdFromOptions();
          }, 100);
        }
        
        // Update product form
        const currentForm = document.querySelector('form[data-product-form]');
        const newForm = newDoc.querySelector('form[data-product-form]');
        if (currentForm && newForm) {
          currentForm.action = newForm.action;
          currentForm.setAttribute('id', newForm.getAttribute('id'));
          currentForm.setAttribute('data-product-handle', newForm.getAttribute('data-product-handle'));
          currentForm.setAttribute('data-current-product-id', newForm.getAttribute('data-current-product-id'));
          currentForm.innerHTML = newForm.innerHTML;

          // Prefetch product JSON to enable option->variant mapping after swap
          try {
            const handle = currentForm.getAttribute('data-product-handle');
            if (handle) {
              const url = `/products/${handle}.js`;
              fetch(url).then(r => r.json()).then(data => {
                window.__pdpProductData = data;
                console.log('[PDPSizePicker] fetched product data', { handle, variants: data?.variants?.length });
              }).catch(err => console.log('[PDPSizePicker] fetch product data failed', err));
            }
          } catch (e) { console.log('[PDPSizePicker] prefetch product data error', e); }

          // Bind listeners to keep hidden id in sync with option changes
          const productSectionRef = (document.querySelector('.shopify-section[data-section-type="product"]')||document);
          const variantsWrapRef = productSectionRef.querySelector('[data-product-variants]');
          let optionInputs = [];
          if (variantsWrapRef) optionInputs = Array.from(variantsWrapRef.querySelectorAll('[name^="options"]'));
          if (!optionInputs.length) optionInputs = Array.from(currentForm.querySelectorAll('[name^="options"]'));
          if (!optionInputs.length) optionInputs = Array.from(productSectionRef.querySelectorAll('[name^="options"]'));
          optionInputs.forEach(input => {
            input.addEventListener('change', () => {
              syncHiddenIdFromOptions();
              const variant = getSelectedVariantFromForm();
              if (variant) applySelectedVariantUI(variant);
            });
          });
          // Also listen for fallback variant id select
          const idSelect = currentForm.querySelector('select[name="id"]');
          if (idSelect) {
            idSelect.addEventListener('change', () => {
              syncHiddenIdFromOptions();
              const variant = getSelectedVariantFromForm();
              if (variant) applySelectedVariantUI(variant);
            });
          }
          // Log and bind delegated listeners
          bindVariantOptionListeners();
          // On submit, force-sync id right before serialize
          currentForm.addEventListener('submit', function(e) {
            try {
              e.preventDefault();
            } catch(_) {}
            console.log('[PDPSizePicker] form submit intercepted');
            syncHiddenIdFromOptions();
            // Enforce only hidden id is submitted
            const currentHidden = currentForm.querySelector('input[type="hidden"][name="id"]')?.value;
            normalizeIdInputs(currentForm, currentHidden);
            const hiddenId = currentForm.querySelector('input[type="hidden"][name="id"]').value;
            const selectId = currentForm.querySelector('select[data-name="id"], select[name="id"]').getAttribute('name') ? (currentForm.querySelector('select[name="id"]').value) : undefined;
            console.log('[PDPSizePicker] pre-addItem id snapshot', { hiddenId, selectId });
            // Use theme cart API to add item
            try {
              if (window.cart && typeof window.cart.addItem === 'function') {
                window.cart.addItem(currentForm).then(({ item }) => {
                  try {
                    // Open quick cart if available
                    if (typeof window.dispatchEvent === 'function') {
                      const evt = new CustomEvent('cart:open', { detail: { flash: item?.variant_id } });
                      window.dispatchEvent(evt);
                    }
                    console.log('[PDPSizePicker] addItem success (window.cart)');
                  } catch(_) {}
                }).catch((err) => { console.log('[PDPSizePicker] addItem error (window.cart)', err); });
              } else if (typeof cart !== 'undefined' && typeof cart.addItem === 'function') {
                cart.addItem(currentForm).then(({ item }) => {
                  try {
                    const evt = new CustomEvent('cart:open', { detail: { flash: item?.variant_id } });
                    window.dispatchEvent(evt);
                  } catch(_) {}
                  console.log('[PDPSizePicker] addItem success (cart global)');
                }).catch((err) => { console.log('[PDPSizePicker] addItem error (cart global)', err); });
              } else {
                console.log('[PDPSizePicker] addItem API not found, using direct fetch');
                // Fallback: submit to /cart/add.js
                const formData = new FormData(currentForm);
                // Ensure id is set
                if (!formData.get('id') && hiddenId) {
                  formData.set('id', hiddenId);
                }
                const body = new URLSearchParams(formData).toString();
                console.log('[PDPSizePicker] direct fetch body', body);
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  body
                }).then(r => r.json()).then(res => {
                  console.log('[PDPSizePicker] direct fetch add.js response', res);
                  try {
                    const evt = new CustomEvent('cart:open', { detail: { flash: res?.variant_id } });
                    window.dispatchEvent(evt);
                  } catch(_) {}
                }).catch(err => {
                  console.log('[PDPSizePicker] direct fetch add.js error', err);
                });
              }
            } catch (err) {
              console.log('Direct addItem submit handler failed:', err);
            }
          });
          // Initial sync
          syncHiddenIdFromOptions();

          // Fully reinitialize product section so ProductForm is rebuilt with new inputs
          reinitProductSection();
          // After reinit, bind listeners again as safety
          bindVariantOptionListeners();
        }

        const loadEvent = new Event('load');
        const currentProductForm = document.querySelector('.custom-product');
        if (currentProductForm) {
          currentProductForm.dispatchEvent(loadEvent);
        }
        
        const currentSmallDesc = document.querySelector('.content-item_text');
        const newSmallDesc = newDoc.querySelector('.content-item_text');
        if (currentSmallDesc && newSmallDesc) {
          currentSmallDesc.innerHTML = newSmallDesc.innerHTML;
        }
        
        const currentMeasurementWrappers = document.querySelectorAll('[js-product-measurement-info-wrapper]');
        const newMeasurementWrappers = newDoc.querySelectorAll('[js-product-measurement-info-wrapper]');
        
        currentMeasurementWrappers.forEach(wrapper => wrapper.remove());
        
        if (newMeasurementWrappers.length > 0) {
          const insertPoint = document.querySelector('.product__media-container .product__media__content--media');
          newMeasurementWrappers.forEach(wrapper => {
            if (insertPoint && insertPoint.parentNode) {
              insertPoint.parentNode.insertBefore(wrapper.cloneNode(true), insertPoint.nextSibling);
            }
          });
        }
        
        const currentDeliveryText = document.querySelector('[js-hb-about-delivery]');
        const newDeliveryText = newDoc.querySelector('[js-hb-about-delivery]');
        if (currentDeliveryText && newDeliveryText) {
          currentDeliveryText.innerHTML = newDeliveryText.innerHTML;
        }
        
        const currentProductJson = document.querySelector('#ProductJson-' + document.querySelector('[data-section-id]').getAttribute('data-section-id'));
        const newProductJson = newDoc.querySelector('#ProductJson-' + newDoc.querySelector('[data-section-id]').getAttribute('data-section-id'));
        if (currentProductJson && newProductJson) {
          currentProductJson.textContent = newProductJson.textContent;
          // Cache latest product data for later variant computations
          try {
            window.__pdpProductData = JSON.parse(newProductJson.textContent);
            console.log('[PDPSizePicker] cached product data', { variants: window.__pdpProductData?.variants?.length });
          } catch(_) {
            window.__pdpProductData = undefined;
          }
        }

        const currentProductMetafieldContentItem = document.querySelector('.content-block_flexer.metafield-content-item');
        const newProductMetafieldContentItem = newDoc.querySelector('.content-block_flexer.metafield-content-item');
        if (currentProductMetafieldContentItem && newProductMetafieldContentItem) {
          currentProductMetafieldContentItem.innerHTML = newProductMetafieldContentItem.innerHTML;
        }
        
        // Update breadcrumbs if they exist
        const currentBreadcrumbs = document.querySelector('.breadcrumbs');
        const newBreadcrumbs = newDoc.querySelector('.breadcrumbs');
        if (currentBreadcrumbs && newBreadcrumbs) {
          currentBreadcrumbs.innerHTML = newBreadcrumbs.innerHTML;
        }
        
        // Note: Variant change event is now triggered in the variant container update section above

        const currentDetailSection = document.querySelector('.detail-section');
        const newDetailSection = newDoc.querySelector('.detail-section');
        if (currentDetailSection && newDetailSection) {
          currentDetailSection.innerHTML = newDetailSection.innerHTML;
        }
        
        const currentReviewSection = document.querySelector('.review-section');
        const newReviewSection = newDoc.querySelector('.review-section');
        if (currentReviewSection && newReviewSection) {
          currentReviewSection.innerHTML = newReviewSection.innerHTML;
          window.initReviewSection();
        }
        
        const currentVariantJsonScript = document.querySelector('[data-variant-json]');
        const newVariantJsonScript = newDoc.querySelector('[data-variant-json]');
        if (currentVariantJsonScript && newVariantJsonScript) {
          currentVariantJsonScript.innerHTML = newVariantJsonScript.innerHTML;
        }
        
        const currentVariantCustomData = document.querySelector('[data-variant-custom-data]');
        const newVariantCustomData = newDoc.querySelector('[data-variant-custom-data]');
        if (currentVariantCustomData && newVariantCustomData) {
          const newScript = document.createElement('script');
          Array.from(newVariantCustomData.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.textContent = newVariantCustomData.textContent;
          currentVariantCustomData.parentNode.replaceChild(newScript, currentVariantCustomData);
        }
        
        const currentProductBundleMobile = document.querySelector('.product-bundle__mobile');
        const newProductBundleMobile = newDoc.querySelector('.product-bundle__mobile');
        if (currentProductBundleMobile && newProductBundleMobile) {
          currentProductBundleMobile.innerHTML = newProductBundleMobile.innerHTML;
        }
        
        const currentProductBundleDesktop = document.querySelector('.product-bundle__desktop');
        const newProductBundleDesktop = newDoc.querySelector('.product-bundle__desktop');
        if (currentProductBundleDesktop && newProductBundleDesktop) {
          currentProductBundleDesktop.innerHTML = newProductBundleDesktop.innerHTML;
        }

        const currentFaqSection = document.querySelector('.faq-section');
        const newFaqSection = newDoc.querySelector('.faq-section');
        if (currentFaqSection && newFaqSection) {
          currentFaqSection.innerHTML = newFaqSection.innerHTML;
        }

        const currentDividedPriceWrapper = document.querySelector('.product__divided-price-wrapper');
        const newDividedPriceWrapper = newDoc.querySelector('.product__divided-price-wrapper');
        if (currentDividedPriceWrapper && newDividedPriceWrapper) {
          currentDividedPriceWrapper.innerHTML = newDividedPriceWrapper.innerHTML;
        }

        window.initAccordion();

      } catch (error) {
        console.error('Error updating product info:', error);
        // Fallback to regular page redirect if something goes wrong
        window.location.href = productUrl;
      } finally {
        // Remove loading state
        const container = document.querySelector('.product__size-picker');
        if (container) container.classList.remove('size-picker-loading');
      }
    };

    var calculateScrollProgress = (container, dragging = false, initialize = false) => {
      if (!container) return;
      const activeImage = container.querySelector('[js-image].active');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      const imageList = container.querySelector('[js-image-list]');
      if (!scrollBar || !imageList) return;
      imageList.scrollTo(activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + imageList.scrollLeft - (imageList.clientWidth - activeImage.clientWidth) / 2, 0);
      if (!dragging) {
        setTimeout(() => {
          scrollBar.style.setProperty('--progress', activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + activeImage.offsetWidth / 2 + 'px');
        }, 150);
        if (!initialize) {
          setTimeout(() => {
            const productUrl = activeImage.getAttribute('data-href');
            if (productUrl) {
              updateProductInfo(productUrl);
            }
          }, 300);
        }
      }
    }
    
    var moveScrollBar = (container, percent, dragging = false) => {
      if (!container) return;
      const totalIndex = parseInt(container.getAttribute('data-total-index')) - 1;
      const unitPercent = 100 / totalIndex;
      let index = 0;
      if (percent <= unitPercent / 2) {
        index = 0;
      } else if (percent > (100 - unitPercent / 2)) {
        index = totalIndex;
      } else {
        for (let i = 1; i <= totalIndex - 1; i++) {
          if (percent > (unitPercent / 2 + unitPercent * (i - 1)) && percent <= (unitPercent / 2 + unitPercent * i)) {
            index = i;
          }
        }
      }
      setCurrentImage(container, container.querySelector(`[js-image][data-index="${index}"]`), dragging);
    }
    
    var setCurrentImage = (container, image, dragging = false) => {
      if (!container || !image) return;
      container.querySelectorAll('[js-image]').forEach(element => {
        element.classList.remove('active');
      });
      image.classList.add('active');
      calculateScrollProgress(container, dragging);
    }
    
    var startDragScroll = (container) => {
      if (!container) return;
      container.classList.add('dragging');
    }
    
    var dragScroll = (container, x) => {
      if (!container || !container.classList.contains('dragging')) return;
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0s');
      let progressValue = x - scrollBar.getBoundingClientRect().left;
      progressValue = (progressValue<0)?0:progressValue;
      progressValue = (progressValue>scrollBar.clientWidth)?(scrollBar.clientWidth):progressValue;
      scrollBar.style.setProperty('--progress', progressValue + 'px');
      moveScrollBar(container, progressValue*100/scrollBar.clientWidth, true);
    }
    
    var endDragScroll = (container) => {
      if (!container || !container.classList.contains('dragging')) return;
      container.classList.remove('dragging');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0.3s');
      calculateScrollProgress(container);
    }
    
    var initEachSlider = (container) => {
      if (!container) return;
      const imageList = container.querySelector('[js-image-list]');
      if (imageList && imageList.scrollWidth == imageList.clientWidth) {
        imageList.style.justifyContent = 'space-around';
      }
      calculateScrollProgress(container, false, true);
      container.querySelectorAll('[js-image]').forEach(element => {
        element.addEventListener('click', () => {
          setCurrentImage(container, element);
        });
      });
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.addEventListener('click', (event) => {
        moveScrollBar(container, (event.clientX - scrollBar.getBoundingClientRect().left) * 100 / scrollBar.clientWidth);
      });
      const scrollHandler = container.querySelector('[js-scroll-handler]');
      if (!scrollHandler) return;
      scrollHandler.addEventListener('mousedown', () => {
        startDragScroll(container);
      });
      document.addEventListener('mousemove', (event) => {
        dragScroll(container, event.clientX);
      });
      document.addEventListener('mouseup', () => {
        endDragScroll(container);
      });
      scrollHandler.addEventListener('touchstart', () => {
        startDragScroll(container);
      });
      document.addEventListener('touchmove', (event) => {
        dragScroll(container, event.touches[0].clientX);
      });
      document.addEventListener('touchend', () => {
        endDragScroll(container);
      });
    }
    
    var initialize = () => {
      document.querySelectorAll('[js-pdp-size-picker]').forEach(container => {
        initEachSlider(container);
      });
    }
    
    return {
      init: initialize
    }
  })();

  var ThresholdSystemApp = (() => {
    var isAddedGiftProduct = (cart, variant_id) => {
      let result = false;
      Array.from(cart.items).forEach(item => {
        if (item.variant_id == variant_id && item.properties['_is_free_gift'] === 'true') {
          result = true;
        }
      });
      return result;
    }
    var addGiftProduct = async (variant_id, required_product_id_list, required_product_count) => {
      const cart = await window.cart.get();
      if (isAddedGiftProduct(cart, variant_id)) {
        return;
      }
      if (required_product_count > 0) {
        window.cart.addItemById(variant_id, 1, {'_is_free_gift': 'true', '_required_product_id_list': required_product_id_list, '_required_product_count': required_product_count});
      }
    }
    var updateThreshold = (container, cart) => {
      if (!container || !cart) return;
      let product_from_collection_count = 0;
      let current_step = 0;
      const product_id_list = String(container.getAttribute('data-threshold-product-id-list-for-gift')).split(',');
      Array.from(cart.items).forEach(item => {
        current_step = 1;
        if (product_id_list.includes(String(item.variant_id))) {
          product_from_collection_count+=item.quantity;
        }
      });
      if (product_from_collection_count >= parseInt(container.getAttribute('data-threshold-collection-product-count'))) {
        current_step = 2;
      }
      container.querySelectorAll('[is-free-gift]').forEach(element => {
        element.classList.remove('is-adding');
      });
      let progress = product_from_collection_count * 100 / parseInt(container.getAttribute('data-threshold-collection-product-count'));
      progress = (progress > 100) ? 100 : progress;
      container.style.setProperty('--progress', progress + '%');
      container.setAttribute('data-step', current_step);
      let successFlag = false;
      if (current_step == 2) {
        successFlag = true;
      }
      container.querySelectorAll('[is-free-gift]').forEach(element => {
        element.classList.remove('d-none');
        if (isAddedGiftProduct(cart, element.getAttribute('is-free-gift'))) {
          element.classList.add('d-none');
        } else {
          successFlag = false;
        }
      });
      if (successFlag == true) {
        container.setAttribute('data-step', 'success');
      }
    }
    var initEachContainer = (container) => {
      if (!container) {
        return;
      }
      if (parseInt(container.getAttribute('data-step')) == 2) {
        let successFlag = true;
        container.querySelectorAll('[is-free-gift]').forEach(element => {
          if (!element.classList.contains('d-none')) successFlag = false;
        });
        if (successFlag) {
          container.setAttribute('data-step', 'success');
        }
      }
      document.addEventListener('cart:updated', (event) => {
        updateThreshold(container, event.detail.cart);
      });
      container.querySelectorAll('[is-free-gift] [js-atc]').forEach(element => {
        element.addEventListener('click', () => {
          const wrapper = element.closest('[is-free-gift]');
          if (wrapper.classList.contains('is-adding')) return;
          wrapper.classList.add('is-adding');
          addGiftProduct(wrapper.getAttribute('is-free-gift'), container.getAttribute('data-threshold-product-id-list-for-gift'), parseInt(container.getAttribute('data-threshold-collection-product-count')));
        });
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-threshold-system]').forEach(container => {
        initEachContainer(container);
      });
    }
    return {
      init: initialize
    }
  })();

  var CollectionFilterTabApp = (() => {
    var filter = (trigger_id, container) => {
      if (!trigger_id || trigger_id === '' || !container) return;
      container.querySelectorAll('[js-trigger]').forEach(element => {
        if (element.getAttribute('js-trigger') === String(trigger_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
      window.mediaFlickityInstances.forEach(element => {
        element.select(parseInt(trigger_id));
      });
    }
    var initialize = () => {
      let firstView = true;
      const targetElement = document.querySelector('.collection__products .product-item'); 

      if (!targetElement) return;

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && firstView) {
            firstView = false;
            setTimeout(() => {
              const firstMediaWrapper = window.mediaFlickityInstances[0];
              if (firstMediaWrapper) {
                firstMediaWrapper.select(1);
                setTimeout(() => {
                  firstMediaWrapper.select(0);
                }, 500);
              }
            }, 1000);
          }
        });
      }, {
        // Optional: configuration options for the observer
        // root: null (default, observes intersection with the viewport)
        // rootMargin: '0px 0px 0px 0px' (default, no margin)
        // threshold: 0.5 (triggers when 50% of the element is visible)
      });
      observer.observe(targetElement);
      document.querySelectorAll('[js-collection-filter] [js-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          filter(element.getAttribute('js-trigger'), element.closest('[js-collection-filter]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      CollectionBundleHighlightApp.init();
      AnchorApp.init();
      PDPSizePickerApp.init();
      ProductMeasurementInfoWrapperApp.init();
      ThresholdSystemApp.init();
      CollectionFilterTabApp.init();
      // Initialize custom dropdowns on page load
      initializeCustomDropdowns();
    }
    return {
      init: initialize
    }
  })();


  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();

const mainCollection = document.querySelector("[js-main-collection]");
if(mainCollection) {

  document.addEventListener("click", function({ target }) {
    const filterApplyBtn = mainCollection.querySelector("[js-filter-apply-btn]");
    const sortByField = mainCollection.querySelector("[js-sort-by-field]");

    if(target.hasAttribute('js-sort-by-item')) {
      const value = target.getAttribute("data-value");
      sortByField.value = value;

      // filterApplyBtn?.dispatchEvent(new Event('click'));
      filterApplyBtn?.click();
    };

    if(!target.closest("[js-sort-by-details]")) {
      mainCollection.querySelector("[js-sort-by-details][open]")?.removeAttribute("open")
    }
  });

  document.addEventListener("change", function({ target }) {
    if(target.hasAttribute('js-filter-checkbox-item')) {
      const filterApplyBtn = mainCollection.querySelector("[js-filter-apply-btn]");
      // filterApplyBtn?.dispatchEvent(new Event('click'));
      filterApplyBtn?.click();
    };
  })
}